const EuroFormatter = new Intl.NumberFormat('fr-FR', { currency: 'EUR', style: 'currency' });

/**
 * Formats a numeric value as a currency value in Euro (€) using French (France) locale formatting.
 *
 * @param {string | number} value - The numeric string to be formatted as currency.
 * @returns {string} The formatted currency string in Euro (€) according to the French (France) locale.
 */
export const formatCurrency = (value: string | number) => EuroFormatter.format(+value);
